import { useChapterDelete } from '@/module/Author/Chapter';

import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

interface ChapterDeleteButtonProps {
  chapterId: Id;
}

export function ChapterDeleteButton({ chapterId }: ChapterDeleteButtonProps) {
  const mutation = useChapterDelete(chapterId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      miw="100px"
      size="xs"
      {...deleteProps}
    />
  );
}
